<template>
  <div class="alertInPage hover">
    <template v-for="e in messages">
      <div :class="'alert alert-'+e.type" role="alert">
        {{e.msgPre}} {{ $t(e.msg) }} {{e.msgPost}}
        <!-- - {{e.delay}}-->
      </div>
    </template>
  </div>
</template>

<script>
  /*
   alert type:
   primary
   secondary
   success
   danger
   warning
   info
   light
   dark
   */
  export default {
    name: 'Alert',
    data(){
      return {
        messages: [],
        timer: void 0,
      }
    },
    mounted() {
      const modul = this;
      modul.$eventBus.$on('globalAlert', this.globalAlertEventHandler);
      modul.startTimer();
    },
    beforeDestroy() {
      this.$eventBus.$off('globalAlert');
    },
    props: {
    },
    watch: {
    },
    methods: {
      globalAlertEventHandler (data) {
        const modul = this;
        if (data.id_delete) {
          const messages = [];
          Array.prototype.forEach.call(modul.messages, function (e, x) {
            if (data.id_delete !== e.id) {
              messages.push(e);
            }
          });
          const copiedData = Object.assign({}, data)
          delete(data.id_delete);
          if (Object.keys(copiedData).length !== 0) {
            messages.push(data);
          }
          if(messages.length>5){
            messages.shift();
          }
          modul.messages = messages
        } else {
        const messages = modul.messages;
          const copiedData = Object.assign({}, data)
          copiedData.delay = (copiedData.delay)?copiedData.delay:5000;
          copiedData.msgPre = (copiedData.msgPre)?copiedData.msgPre:"";
          copiedData.msg = (copiedData.msg)?copiedData.msg:"";
          copiedData.msgPost = (copiedData.msgPost)?copiedData.msgPost:"";
          messages.push(copiedData);
          if(messages.length>5){
            messages.shift();
          }
          modul.messages = messages
        }
      },
      startTimer(){
        const modul = this;
        modul.timer = setInterval(function () {
          const messages = [];
          Array.prototype.forEach.call(modul.messages, function (e, x) {
            e.delay = e.delay - 500;
            if (e.delay > 0) {
              messages.push(e)
            }
          });
          modul.messages = messages
        }, 500)
      },
    }

  };
</script>

<style>
  .alertInPage.hover {
    position: fixed;
    top: 25px;
    right: 100px;
    z-index: 10;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.7);
    border-radius: .25rem;
  }

  .alertInPage > div {
    margin-bottom: 0;
  }

</style>


